/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Return_WebInputs */

const en_mcp_connect_return_web = /** @type {(inputs: Mcp_Connect_Return_WebInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`After you choose, you’ll return to ${i?.app} at`)
};

const es_mcp_connect_return_web = /** @type {(inputs: Mcp_Connect_Return_WebInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Después de elegir, volverás a ${i?.app} en`)
};

/**
* | output |
* | --- |
* | "After you choose, you’ll return to {app} at" |
*
* @param {Mcp_Connect_Return_WebInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_return_web = /** @type {((inputs: Mcp_Connect_Return_WebInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Return_WebInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_return_web(inputs)
	return en_mcp_connect_return_web(inputs)
});